import './SurveyPageForm.scoped.scss'
import questionTypes from './question-types'
import QuestionForm from './QuestionForm';

export default function EditQuestion({ questionId }) {
  const question = useSel(s => s.questions.entities[questionId])
  const mergeTags = useSel(s => s.builder.mergeTags)
  const questionConfig = questionTypes[question.questionType]

  if (!questionTypes[question.questionType]) {
    throw new Error(`Unsupported question type: ${question.questionType}`)
  }

  return <QuestionForm question={question} mergeTags={mergeTags} questionConfig={questionConfig} />
}
